import { cleanse } from 'utils';

export const documentsBodyFactory = (formData) => {
	const { policyNumber, scannedDocument, documentType, firstName, ...restFormData } = formData;

	let personIn;
	let businessIn;

	if (formData.personIn) {
		if (restFormData.personIn.length === 8) {
			businessIn = restFormData.personIn;
		} else {
			personIn = restFormData.personIn;
		}
	}

	return cleanse({
		...restFormData,
		personIn,
		businessIn,
		policyNo: policyNumber,
		scanned: scannedDocument,
		documentTypeId: documentType,
		firstname: firstName,
	});
};
